import {autoImplement} from '@/util';
import moment from 'moment';
import {ApiPosition} from './Task';
import {FulltextSearch} from '@/api/meta/filters';
import {ApiFile} from './File';

export interface ApiLieferung {
  GeplantLieferdatum: string | null
}
export interface ApiDeliveryNote {
  VerkauflieferscheinNr: number,
  AuftragNr: number,
  RechnungNr: number,
  Datum: string,
  UhrZeit: string,
  Bediener: string,
  Gutschrift: unknown | null,
  Gedruckt: boolean,
  Ausgeliefert: boolean,
  Vertreter: string,
  Vertreter2: string,
  Kostenstelle: number,
  Niederlassung: number,
  KundenNr: number,
  DebitorKonto: number,
  Kundname: string,
  RechnungHauptkunde: string,
  Positionen: ApiPosition[],
  Archiv?: { Values: ApiFile[] | null },
  Dateien?: { Values: ApiFile[] },
  Unterlagen?: { Values: ApiFile[] },
  Lieferung: ApiLieferung,
}

export interface DeliveryNoteFilters {
  KundenNr?: number;
  VerkauflieferscheinNr?: number;
  Ausgeliefert?: boolean;
  Datum$From?: string;
  Datum$To?: string;
  'Lieferung/GeplantLieferdatum$From'?: string;
  'Lieferung/GeplantLieferdatum$To'?: string;
  Fulltext$Fulltext: FulltextSearch;
}
export interface DetailDeliveryNoteFilters {
  VerkauflieferscheinNr?: number;
}

export default class DeliveryNote extends autoImplement<ApiDeliveryNote>() {
  static fromApi(apiDeliveryNote: ApiDeliveryNote): DeliveryNote {
    return new DeliveryNote(apiDeliveryNote);
  }

  get color() {
    return this.Ausgeliefert ? 'error' : 'success';
  }
  get status() {
    return this.Ausgeliefert ? 'Ausgeliefert' : 'Nicht Ausgeliefert';
  }
  get icon() {
    return this.Ausgeliefert ? 'mdi-check' : null;
  }
  get DatumFormatted() {
    return moment(this.Datum).format('DD.MM.YYYY');
  }

  get GeplantLieferdatumFormatted() {
    const parsedGeplantLieferdatum = moment(this.Lieferung.GeplantLieferdatum);
    const datePart = parsedGeplantLieferdatum.format('DD.MM.YYYY');
    const timePart = parsedGeplantLieferdatum.format('HH:mm');
    if (timePart !== '00:00') return `${datePart} ${timePart}`;
    return datePart;
  }
}
